import { ChangeDetectorRef, Component, inject, Input } from '@angular/core';
import { SharedUserService } from '@luggagehero/shared/services/users';
import { SharedWindowService } from '@luggagehero/shared/services/window';

import { BaseModalComponent } from '../../../core';
@Component({
  template: '',
  standalone: false,
})
export abstract class UserModalBaseComponent extends BaseModalComponent {
  private _isStorageManager = false;
  private _isExistingUser = true;
  private _isUserEmailSelected: boolean;
  private _isUserPhoneSelected: boolean;
  private _userEmail: string;
  private _navigateHomeOnHide = false;
  private _isForBooking = false;
  private _isContactDetails = false;

  protected windowService = inject(SharedWindowService);
  protected userService = inject(SharedUserService);
  protected cd = inject(ChangeDetectorRef);

  get modalTitle(): string {
    if (this.isStorageManager) {
      return this._translate('WELCOME');
    }
    if (this.isContactDetails) {
      return this._translate('YOUR_CONTACT_DETAILS');
    }
    if (this.isUserEmailSelected || this.isUserPhoneSelected) {
      return this._translate(this.isExistingUser ? 'WELCOME_BACK' : 'FIRST_TIME_USING_LUGGAGEHERO');
    }
    return this._translate('SIGN_IN');
  }

  /** The booking's confirm step opened sign-in, so it asks for contact details (AM-5050) */
  get isContactDetails(): boolean {
    return this._isContactDetails;
  }
  @Input() set isContactDetails(value: boolean) {
    this._isContactDetails = value;
    this.cd.markForCheck();
  }

  get ios(): boolean {
    return this.windowService.iOS;
  }

  get isStorageManager(): boolean {
    return this._isStorageManager;
  }
  @Input() set isStorageManager(value: boolean) {
    this._isStorageManager = value;
    this.cd.markForCheck();
  }

  get isUserEmailSelected(): boolean {
    return this._isUserEmailSelected;
  }
  set isUserEmailSelected(value: boolean) {
    this._isUserEmailSelected = value;
    this.cd.markForCheck();
  }

  get isUserPhoneSelected(): boolean {
    return this._isUserPhoneSelected;
  }
  set isUserPhoneSelected(value: boolean) {
    this._isUserPhoneSelected = value;
    this.cd.markForCheck();
  }

  get isExistingUser(): boolean {
    return this._isExistingUser;
  }
  set isExistingUser(value: boolean) {
    this._isExistingUser = value;
    this.cd.markForCheck();
  }

  get userEmail(): string {
    return this._userEmail;
  }
  set userEmail(value: string) {
    this._userEmail = value;
    this.cd.markForCheck();
  }

  get isForBooking(): boolean {
    return this._isForBooking;
  }
  @Input() set isForBooking(value: boolean) {
    this._isForBooking = value;
    this.cd.markForCheck();
  }

  get navigateHomeOnHide(): boolean {
    return this._navigateHomeOnHide;
  }
  set navigateHomeOnHide(value: boolean) {
    this._navigateHomeOnHide = value;
    this.cd.markForCheck();
  }
}
